import * as React from 'react';
import { useContext } from 'react';
var idContext = React.createContext("lqx");
export var LqxTitle = idContext.Provider;
export function useQaId(id) {
    return useContext(idContext) + "-" + String(id).toLowerCase();
}
//# sourceMappingURL=qa-ids.js.map